import React from 'react';
import { RequestIdTableCell } from '../RequestIdTableCell';

export const RequestWarranty = {
    Header: () => 'Garantía vehicular',
    id: 'id',
    typeId: 'HeaderRequest',
    Cell: ({ row }) => {
        return (
            <RequestIdTableCell
                row={row}
                url={`/app/warranty/list/process/${row.original.id}/${row.original.solicitud.persona.numero_identificacion}/${row.original.solicitud.persona.pk}/${row.original.solicitud.id}`}
                idRoute={row.original.id}
            />
        );
    },
};

export const RequestWarrantyRadication = {
    Header: () => 'Garantía vehicular',
    id: 'id',
    typeId: 'HeaderRequest',
    Cell: ({ row }) => {
        return (
            <RequestIdTableCell
                row={row}
                url={`/app/radicationWarranty/list/process/${row.original.id}/${row.original.solicitud.persona.numero_identificacion}/${row.original.solicitud.persona.pk}/${row.original.solicitud.id}`}
                idRoute={row.original.id}
            />
        );
    },
};

export const RequestConsult = {
    Header: () => 'Solicitud',
    id: 'id',
    typeId: 'HeaderRequest',
    Cell: ({ row }) => {
        return (
            <RequestIdTableCell
                row={row}
                url={`/app/consultRequest/detail/${row.original.persona.numero_identificacion}/${row.original.pk}/${row.original.persona.pk}`}
                idRoute={row.original.pk}
            />
        );
    },
};
